import { useEffect } from "react";
import { db } from "../../firebase/config";
import { useDispatch, useSelector } from "react-redux";
import { TalesArea } from "../types/TalesArea";
import { setAreeData } from "../../store/aree/actions/setData";
import { usedHooks } from "../../store/site/selectors";
import { addUsedHook } from "../../store/site/actions/addUsedHook";
import { setAreeError } from "../../store/aree/actions/setError";

export default function useAree() {
  const dispatch = useDispatch();
  const hooks = useSelector(usedHooks);

  useEffect(() => {
    if (!hooks.includes("useAree")) {
      dispatch(addUsedHook("useAree"));
      db.collection("aree")
        .orderBy("order")
        .onSnapshot((snapshot) => {
          if (snapshot.empty) {
            dispatch(setAreeError("Non è stata trovata nessuna area"));
          } else {
            let aree: TalesArea[] = [];
            snapshot.docs.forEach((doc) => {
              aree = [...aree, doc.data() as TalesArea];
            });
            dispatch(setAreeData(aree));
          }
        });
    }
  }, [dispatch, hooks]);
}
